import * as actionTypes from '../action/actionTypes';
import { updateObject } from '../../utils';

const initialState = {
  token: null,
  error: null,
  loading: false,
  isIPBlocked: false
};

const authStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true
  });
};

const authSuccess = (state, action) => {
  return updateObject(state, {
    token: action.token,
    error: null,
    loading: false
  });
};

const authFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false
  });
};

const authLogout = (state, action) => {
  return updateObject(state, {
    token: null
  });
};

const setIPBlocked = (state, action) => {
  return updateObject(state, {
    isIPBlocked: !!action.isIPBlocked
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);
    case actionTypes.SET_IP_BLOCKED: // handle new action
      return setIPBlocked(state, action);
    default:
      return state;
  }
};

export default reducer;
